/* global TweenMax Quad */
import React from 'react';
// import ReactDOM from 'react-dom';
// import ReactScene from 'react-scene';
import _ from 'lodash';
// import { Helmet } from 'react-helmet';
import classNames from 'classnames';

import Texts from '../../data/texts.json';
import Extras from '../../data/extras.json';

import TopMenu from '../partials/TopMenu.jsx';
import LearnMore from '../partials/LearnMore.jsx';
import Messenger from '../partials/Messenger.jsx';
import Bubbles from '../partials/Bubbles.jsx';

import StageActions from '../../actions/StageActions';

import Audio from '../../lib/audio';
import Scenes from '../../data/scenes.json';
import Chapters from '../../data/chapters/index';

import { isMobile } from '../../lib/isMobile';

import normalizeWheel from '../../lib/normalizeWheel';

const mobile = isMobile();

const Scene = React.createClass({

    propTypes: {
        rendererType: React.PropTypes.string.isRequired,
        intensity: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        frameWidth: React.PropTypes.number,
        frameHeight: React.PropTypes.number,
        frameScale: React.PropTypes.number,
        device: React.PropTypes.string,
        showBackButton: React.PropTypes.bool,
        scrollable: React.PropTypes.bool,
        mouseDown: React.PropTypes.bool,

        storiesContainer: React.PropTypes.object,
        objectsWithTextures: React.PropTypes.object,
        frameIndex: React.PropTypes.number,
        learnMoreOpened: React.PropTypes.bool,
        snap: React.PropTypes.bool,

        pageKey: React.PropTypes.string,
        sceneKey: React.PropTypes.string,
        framesClasses: React.PropTypes.array,
        framesTransitions: React.PropTypes.object,
        framesRenderExceptions: React.PropTypes.object,
        framesToRender: React.PropTypes.array,

        onFrameIndexChanged: React.PropTypes.func,
        onFrameOffsetChanged: React.PropTypes.func,
        onExactFrameIndexChanged: React.PropTypes.func,
        onExactFrameOffsetChanged: React.PropTypes.func,
        onSceneChange: React.PropTypes.func,
        onToggleMenu: React.PropTypes.func,

        onMessageWillShow: React.PropTypes.func,
        onMessageShow: React.PropTypes.func,
        onWindowResize: React.PropTypes.func.isRequired,
        onWindowFocus: React.PropTypes.func.isRequired,
        setPreviousVolume: React.PropTypes.func.isRequired,

        mainContainer: React.PropTypes.object,
    },

    contextTypes: {
        playing: React.PropTypes.bool,
        store: React.PropTypes.object,
        events: React.PropTypes.object,
        crisis: React.PropTypes.bool,
        crisisSound: React.PropTypes.bool,
        originalWidth: React.PropTypes.number,
        originalHeight: React.PropTypes.number,
        minIntensity: React.PropTypes.number,
        interactionsCompleted: React.PropTypes.object,
        scenesCompleted: React.PropTypes.object,
        language: React.PropTypes.string,
        learnMoreKey: React.PropTypes.string,
        messageBoxPlaying: React.PropTypes.bool,
        menuOpen: React.PropTypes.bool,
        learnMoreOpened: React.PropTypes.bool,
        framesDone: React.PropTypes.object,
    },

    frameCount: 0,
    audios: {},
    momentumXtimeout: null,
    autoSnapTimeout: null,
    interactionsTimeout: null,

    getDefaultProps: function() {
        return {
            framesClasses: [],
            framesTransitions: {},
            framesRenderExceptions: {},
            framesToRender: [],
            showBackButton: true,
            scrollable: false,
            showIntensitySelector: true,
            frameIndex: 0,
            frameOffset: 0.5,
            frameBorder: mobile ? 2 : 8,
            minMomentumXforNextSlide: 20,
            loadedProgress: 0,
            objectsWithTextures: null,
            mainContainer: null,
            initialMessageBoxPlaying: true,
            neighboorFramesVisible: mobile ? 1 : 2,
            neighboorPixiFramesVisible: mobile ? 0 : 1,
            instabilityUpdateFramesCount: 10,
            snap: true,
            preventConclusion: false,
            ambiancesUrls: {
                // background: '/audio/30nov/ambiance-niveau-01-30nov.mp3',
                // intensity1: '/audio/30nov/ambiance-niveau-01-30nov.mp3',
                // intensity2: '/audio/30nov/ambiance-niveau-02-30nov.mp3',
                // intensity3: '/audio/30nov/ambiance-niveau-03-30nov.mp3',
                // crisis: '/audio/30nov/ambiance-niveau-05-30nov.mp3',
                // background: '/audio/latest/ambiance1.mp3',

                intensity1: ['/audio/latest/ambiance1.ogg', '/audio/latest/ambiance1.mp3'],
                intensity2: ['/audio/latest/ambiance2.ogg', '/audio/latest/ambiance2.mp3'],
                intensity3: ['/audio/latest/ambiance3.ogg', '/audio/latest/ambiance3.mp3'],
                crisis: ['/audio/latest/ambiance4.ogg', '/audio/latest/ambiance4.mp3'],

            },
            interactionsTimeout: 8,
            interactionsMessageClearDelay: 10,
            messagesIndexes: {},

            onMessageWillShow: null,
            onMessageShow: null,
        };
    },

    getInitialState: function () {
        const props = this.props;
        const showConclusion = false; // this.getShowConclusion(this.context.scenesCompleted);

        return {
            playing: true,

            startY: 0,
            messengerHeight: 0,
            momentumX: 0,
            frameIndex: props.frameIndex,
            frameOffset: props.frameOffset,
            exactFrameIndex: props.frameIndex,
            exactFrameOffset: 0,

            frameIndexChanged: false,
            framesPlaying: this.getFramesPlaying(props.frameIndex, props.frameOffset, showConclusion),
            currentAmbiance: null,
            currentMessages: this.getCurrentMessages(),
            messagesIndexes: this.getCurrentMessagesIndexes(),
            overrideMessages: null,
            interactionsMessages: null,
            animationData: null,

            showConclusion: false,
            conclusionFrameWidth: null,

            panStartY: null,
            messagesCurrentIndexes: [],

            pastMessages: {},
            pastAnswers: {},
            pastIndexes: {},

            isTransitionning: false,
            backgroundVolume: 0.1,
        };
    },

    render: function () {
        const props = this.props;
        const state = this.state;

        const loadingContent = this.renderLoading();
        const interactiveContent = this.renderInteractiveContent();
        const frames = this.renderFrames();

        const arrowLeft = this.renderNavigationArrow('left');
        const arrowRight = this.renderNavigationArrow('right');

        const className = `scene scene-${props.sceneKey} scene-frame-${state.frameIndex}`;

        return (
            <div className={className} style={{ width: props.width, height: props.height }}>
                { frames }
                { loadingContent }
                { interactiveContent }
                { arrowLeft }
                { arrowRight }
            </div>
        );
    },

    renderFrames: function () {
        const props = this.props;
        const state = this.state;
        const context = this.context;

        if (props.objectsWithTextures === null || props.mainContainer === null) {
            return;
        }

        let cropYOffset = 0;
        if (props.frameHeight > props.height) {
            cropYOffset = -((props.frameHeight - props.height) / 6);
        }

        const frameProps = {
            rendererType: props.rendererType,
            intensity: props.intensity,
            storyWidth: props.width,
            storyHeight: props.height,
            frameX: props.frameX,
            frameY: props.frameY,

            width: props.frameWidth,
            height: props.frameHeight,
            scale: props.frameScale,
            border: props.frameBorder,
            device: props.device,

            // fluxRefWidth: props.frameWidth,
            // fluxRefHeight: props.frameHeight,

            cropYOffset,

            fullWidth: props.width,
            fullHeight: props.height,

            devicePixelRatio: props.devicePixelRatio,
            objs: props.objectsWithTextures,
            container: props.mainContainer,
            onAnimationReady: props.onFrameAnimationReady,
            onResumeMessageBox: this.onResumeMessageBox,
            onSceneChange: this.onSceneChange,
            subtitle: Extras[`${props.sceneKey}_slogan`].text[context.language],

            isTransitionning: this.state.isTransitionning,
            onWindowResize: this.props.onWindowResize,
            onAfterBuild: this.onAfterBuild,
        };

        const framesPlaying = state.framesPlaying;

        const frames = props.framesClasses.map((Frame, frameIndex) => {
            const focus = frameIndex === state.frameIndex;
            const isNext = frameIndex > state.frameIndex;

            // let play = framesPlaying[frameIndex];
            // const currentExactFrameIndex =
            //     state.exactFrameIndex
            //     + ((frameIndex === state.exactFrameIndex - 1 || state.exactFrameOffset === 0) ? 0 : 1);
            //
            // if (!play && _.get(props.framesRenderExceptions, frameIndex, []).indexOf(currentExactFrameIndex) > -1) {
            //     play = true;
            // }
            //
            // if (props.framesToRender.indexOf(currentExactFrameIndex) > -1) {
            //     play = true;
            // }

            const play = this.getFrameVisibleState(frameIndex);
            const visible = this.getFrameVisibleState(frameIndex);
            const pixiVisible = this.getPixiFrameVisibleState(frameIndex);

            return (
                <Frame
                    key={`frame-${frameIndex}`}
                    index={frameIndex}
                    play={play}
                    focus={focus}
                    visible={visible}
                    pixiVisible={pixiVisible}
                    isNext={isNext}
                    updateMessages={this.updateOverrideMessages}
                    animationData={this.state.animationData}
                    {...frameProps}
                />
            );
        });
        const originalWidth = context.originalWidth;
        const originalHeight = context.originalHeight;

        const frameWidth = props.frameWidth;
        const frameHeight = props.frameHeight;
        const scale = props.frameScale;
        const framesX = -(state.frameIndex) * (frameWidth + props.frameBorder);

        const style = {
            left: framesX,
            // transform: 'translateX('+framesX+'px)',
            // top: (props.height / 2) - (props.frameHeight / 2),
            // width: props.framesClasses.length * (originalWidth + props.frameBorder * (1/scale)),
            // height: originalHeight,
            width: frameWidth,
            height: frameHeight,
        };

        const containerStyle = {
            width: frameWidth,
            height: frameHeight,
            left: (props.width - frameWidth) / 2,
            top: 0,
        };

        if (props.scrollable === true) {
            containerStyle.overflow = 'scroll';
        }

        return (
            <div className="frames-container" style={containerStyle}>
                <div className="frames" style={style}>
                    { frames }
                </div>
            </div>
        );
    },

    getFrameVisibleState: function (index) {
        const props = this.props;
        const state = this.state;
        return state.exactFrameIndex >= index - props.neighboorFramesVisible - 1 && state.exactFrameIndex <= index + props.neighboorFramesVisible;
    },

    getPixiFrameVisibleState: function (index) {
        const props = this.props;
        const state = this.state;
        return state.exactFrameIndex >= index - props.neighboorPixiFramesVisible - 1 && state.exactFrameIndex <= index + props.neighboorPixiFramesVisible;
    },

    renderLoading: function () {
        const props = this.props;

        if (props.mainContainer !== null && props.objectsWithTextures !== null) {
            return;
        }

        return (
            <div className="loading">
                <div className="loading-gear">
                    <Bubbles progress={props.loadedProgress * 100} />
                </div>
            </div>
        );
    },

    renderInteractiveContent: function () {
        const props = this.props;
        const state = this.state;

        // if (props.objectsWithTextures === null || props.mainContainer === null) {
        //     return;
        // }

        // const frameWidth = props.frameWidth;
        // const frameHeight = props.frameHeight;

        const style = {
            position: 'static',
        };

        const containerStyle = {
            position: 'static',
        };

        const learnMoreVisible =
            _.get(Texts, 'scenes.'+props.sceneKey+'.frames.'+state.frameIndex+'.learnMore', null) !== null;
        const learnMore = this.renderLearnMore(learnMoreVisible);

        const menuComponent = this.renderMenu();
        const desktopBurger = props.width > props.frameWidth + 150;

        const burgerStyle = {
            // marginLeft: desktopBurger ? 0 : 0,
            // left: desktopBurger ? 0 : 0,
            // padding: 25,
        };
        const burgerClassName = classNames({
            'menu-hamburger': true,
            desktop: desktopBurger,
        });
        const messageBox = this.renderMessageBox(false);

        return (
            <div className="interactive-content" style={style}>
                <button
                    className={burgerClassName}
                    style={burgerStyle}
                    onClick={this.props.onToggleMenu}
                />
                <div className="container-frame" style={containerStyle}>
                    { messageBox }
                </div>
                { learnMore }
                { menuComponent }
            </div>
        );
    },

    renderLearnMore: function (visible) {
        // if (!this.props.learnMoreOpened) return;
        const props = this.props;
        const state = this.state;

        const content = _.get(Texts, 'scenes.'+props.sceneKey+'.frames.'+state.frameIndex+'.learnMore');
        const title = _.get(content, 'title');
        const description = _.get(content, 'description');

        return (
            <LearnMore
                ref="learnMore"
                visible={visible}
                title={title}
                description={description}
                width={props.width}
                height={props.height}
                contentMaxWidth={props.frameWidth}
                opened={props.learnMoreOpened}
                onButtonClick={this.onLearnMoreButtonClick}
                onOpened={this.onLearnMoreOpened}
                onClosed={this.onLearnMoreClosed}
            />
        );
    },

    renderMenu: function () {
        const props = this.props;

        return (
            <TopMenu
                visible
                offset={this.state.y}
                width={props.width}
                height={props.height}
                contentMaxWidth={props.mobile ? props.width : props.frameWidth}
                opened={this.context.menuOpen}
                onToggleMenu={this.props.onToggleMenu}
                onOpened={this.onMenuOpened}
                onClosed={this.onMenuClosed}
                mouseDown={this.props.mouseDown}
                setPreviousVolume={this.props.setPreviousVolume}
            />
        );
    },

    renderMessageBox: function () {
        const props = this.props;
        const { startY, currentMessages } = this.state;
        const { messageBoxPlaying } = this.context;
        const crisis = this.context.crisis;

        const { frameWidth, frameHeight, width, height } = props;

        if (props.objectsWithTextures === null || props.mainContainer === null) {
            return;
        }

        let pastMessages = [];
        if (typeof this.state.pastMessages[this.state.frameIndex] !== 'undefined') {
            pastMessages = this.state.pastMessages[this.state.frameIndex];
        }
        let pastAnswers = [];
        if (typeof this.state.pastAnswers[this.state.frameIndex] !== 'undefined') {
            pastAnswers = this.state.pastAnswers[this.state.frameIndex];
        }
        let pastIndex = 0;
        if (typeof this.state.pastIndexes[this.state.frameIndex] !== 'undefined') {
            pastIndex = this.state.pastIndexes[this.state.frameIndex];
        }

        const style = {
            position: 'absolute',
            top: 0,
            bottom: 0, // ((props.height) - frameHeight) / 2,
            width: frameWidth,
            left: '50%',
            marginLeft: `-${frameWidth / 2}`,
            zIndex: 10,
            // backgroundColor: 'black',
        };

        const hasShadow = crisis !== false || !messageBoxPlaying;

        const shadowStyle = {
            backgroundColor: hasShadow ? 'rgba(0, 0, 0, .55)' : 'rgba(0, 0, 0, 0)',
            display: hasShadow ? 'block' : 'none',
            visibility: hasShadow ? 'visible' : 'hidden',
            zIndex: 0,
        };

        return (
            <div>
                <div style={style}>
                    <Messenger
                        mobile={this.props.mobile}
                        y={startY}
                        messages={currentMessages}

                        elevated={false}
                        play={this.context.playing}
                        onGoNextChapter={this.goNextChapter}
                        onGoNextSlide={this.goNextSlide}
                        onOpenLearnMore={this.openLearnMore}
                        onAllMessagesShown={this.onAllMessagesShown}
                        onMessageWillShow={this.onMessageWillShow}
                        onMessageShow={this.onMessageShow}
                        onMessengerHeightChange={this.onMessengerHeightChange}
                        onAnimationCall={this.onMessengerAnimationCall}
                        width={width}
                        height={height}
                        frameWidth={frameWidth}
                        frameHeight={frameHeight}
                        frameIndex={this.state.frameIndex}

                        pastMessages={pastMessages}
                        pastAnswers={pastAnswers}
                        pastIndex={pastIndex}

                        onStoreMessages={this.onStoreMessages}
                    />
                </div>
                <div className="shadow" style={shadowStyle} />
            </div>
        );
    },

    renderNavigationArrow: function (position) {
        const { sceneKey, objectsWithTextures, mainContainer } = this.props;
        if (objectsWithTextures === null || mainContainer === null || this.context.crisis) {
            return;
        }

        const key = sceneKey || '';
        const frames = Chapters[key.toLowerCase()] || {};
        const nextFrame = this.getNextFrameIndex();

        // Exceptions, first and last
        if (position === 'left' && this.state.frameIndex === 0 && sceneKey === 'intro') return;
        if (position === 'right' && nextFrame >= Object.keys(frames).length && sceneKey === 'oligarchie') return;

        const className = `nav-arrow ${position}`;

        const style = {
            position: 'absolute',
            top: 60,
            bottom: 60,
            height: this.props.height - 120,
            width: Math.max(50, (this.props.width - this.props.frameWidth) / 2),
        };

        if (position === 'left') {
            style.left = 0;
        } else {
            style.right = 0;
        }

        return (
            <button
                className="nav-arrow-block"
                style={style}
                onClick={() => {
                    this.changeSlide(position);
                }}
            >
                <div className={className} />
            </button>
        );
    },

    /*
     * React life cycle
     */

    componentWillReceiveProps: function(nextProps, nextContext) {
        // const intensityChanged = this.props.intensity !== nextProps.intensity;
        // const crisisChanged = this.context.crisis !== nextContext.crisis;
        const scenesCompletedChanged = this.context.scenesCompleted !== nextContext.scenesCompleted;
        const state = {};

        if (scenesCompletedChanged) {
            // state.showConclusion = this.getShowConclusion(nextContext.scenesCompleted);
            state.framesPlaying = this.getFramesPlaying(this.state.frameIndex, this.state.frameOffset, state.showConclusion);
        }

        if (_.values(state).length) {
            this.setState(state);
        }
    },

    componentDidMount: function () {
        const props = this.props;
        const context = this.context;

        this.audios = {};

        this.momentumXtimeout = null;
        this.autoSnapTimeout = null;

        _.forOwn(props.ambiancesUrls, (value, key) => {
            this.audios[key] = new Audio(value, {
                loop: true,
                volume: this.state.backgroundVolume,
            });
            // this.audios[key].play();
        });

        context.events.on('tick', this.onTick);
        // context.events.on('mousedown', this.onMouseDown);
        context.events.on('mousemove', this.onMouseMove);
        context.events.on('mouseup', this.onMouseUp);
        context.events.on('wheel', this.onMouseWheel);

        context.events.on('swiperight', this.goPrevSlide);
        context.events.on('swipeleft', this.goNextSlide);

        context.events.on('pan', this.onPan);
        context.events.on('panstart', this.onPanStart);
        context.events.on('panend', this.onPanEnd);

        // console.log('BRO! scene mounted');
        // this.props.onWindowResize();
    },

    componentDidUpdate: function (prevProps, prevState, prevContext) {
        const props = this.props;
        const state = this.state;
        const context = this.context;

        const frameIndexChanged = prevState.frameIndex !== state.frameIndex;
        const frameOffsetChanged = prevState.frameOffset !== state.frameOffset;
        const exactFrameIndexChanged = prevState.exactFrameIndex !== state.exactFrameIndex;
        const exactFrameOffsetChanged = prevState.exactFrameOffset !== state.exactFrameOffset;

        const intensityChanged = prevProps.intensity !== props.intensity;
        const onReady = prevProps.mainContainer === null && props.mainContainer !== null;

        const sceneChanged = this.props.sceneKey !== prevProps.sceneKey;
        const crisisChanged = prevContext.crisis !== this.context.crisis;

        const sizeChanged = prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height ||
            prevProps.frameWidth !== this.props.frameWidth ||
            prevProps.frameHeight !== this.props.frameHeight;
        // var sceneCompletedChanged = _.get(prevContext.scenesCompleted, props.sceneKey, false) !== _.get(this.context.scenesCompleted, props.sceneKey, false);

        if (frameIndexChanged) {
            this.updateFrameIndex();
            this.stopInteractionsTimeout();
            this.context.store.dispatch(StageActions.setMessageBoxPlaying(true));
            this.setState({
                startY: 0,
            });
        }

        if (frameOffsetChanged) {
            this.updateFrameOffset();
            this.stopInteractionsTimeout();
        }

        if (exactFrameIndexChanged) {
            this.updateExactFrameIndex();
            this.stopInteractionsTimeout();
        }

        if (exactFrameOffsetChanged) {
            this.updateExactFrameOffset();
            this.stopInteractionsTimeout();
        }

        if (onReady) {
            props.mainContainer.x -= (props.frameWidth + props.frameBorder) * props.frameIndex;
            this.onIntensityChanged(null, props.intensity);
            if (!this.state.currentMessages || !this.state.currentMessages.length) {
                this.startInteractionsTimeout();
            }
        }

        if (intensityChanged) {
            this.onIntensityChanged(prevProps.intensity, props.intensity);
            this.stopInteractionsTimeout();
        }

        if (crisisChanged) {
            this.onCrisisChanged();
            this.onIntensityChanged(prevProps.intensity, props.intensity);
            this.stopInteractionsTimeout();
        }

        if (sceneChanged) {
            const currentMessages =
                this.getCurrentMessages(props.sceneKey, state.frameIndex, props.intensity, context.crisis);
            this.setState({
                currentMessages,
            }, () => {
                this.context.store.dispatch(StageActions.setMessageBoxPlaying(true));
            });
        }

        if (sizeChanged) {
            if (this.context.menuOpen) {
                TweenMax.to(document.getElementsByClassName('app-content'), 0.1, {
                    y: this.props.height,
                    ease: Quad.easeInOut,
                });
            }

            if (this.context.learnMoreOpened) {
                TweenMax.to(document.getElementsByClassName('app-content'), 0.1, {
                    y: `-${this.props.height}`,
                    ease: Quad.easeInOut,
                });
            }
        }
    },

    componentWillUnmount: function () {
        const props = this.props;
        const state = this.state;
        const context = this.context;

        context.events.off('tick', this.onTick);
        // context.events.off('mousedown', this.onMouseDown);
        context.events.off('mousemove', this.onMouseMove);

        context.events.off('mouseup', this.onMouseUp);
        context.events.off('wheel', this.onMouseWheel);

        context.events.off('swiperight', this.goPrevSlide);
        context.events.off('swipeleft', this.goNextSlide);

        context.events.off('pan', this.onPan);
        context.events.off('panstart', this.onPanStart);
        context.events.off('panend', this.onPanEnd);

        if (props.mainContainer) {
            props.mainContainer.removeChildren();
            TweenMax.killTweensOf(props.mainContainer);
        }

        if (props.storiesContainer) {
            props.storiesContainer.removeChildren();
        }

        if (state.currentAmbiance) {
            state.currentAmbiance.pause({
                fade: true,
            });
        }

        if (this.momentumXtimeout) {
            clearTimeout(this.momentumXtimeout);
            this.momentumXtimeout = null;
        }

        if (this.autoSnapTimeout) {
            clearTimeout(this.autoSnapTimeout);
            this.autoSnapTimeout = null;
        }

        _.forOwn(props.ambiancesUrls, (value, key) => {
            this.audios[key].pause();
            this.audios[key].destroy();
            this.audios[key] = null;
        });

        this.stopInteractionsTimeout();

        this.props.onSceneUnmount();
    },

    onAfterBuild: function () {
        if (!this.count) {
            this.count = 0;
        }
        this.count++;
        if (this.count >= this.props.framesClasses.length) {
             // console.log('WE\'RE READY');
             this.props.onSceneMount();
             setTimeout(() => {
                 // console.log('extra safe resize');
                 this.props.onWindowResize();
                 this.props.onWindowFocus();
             }, 3000);
        }
    },

    getCurrentMessages: function (sceneKey, frameIndex, intensity, crisis) {
        const state = this.state;
        let key = sceneKey;
        if (!sceneKey) {
            key = this.props.sceneKey;
        }

        const index = typeof frameIndex !== 'undefined' ?
            frameIndex : _.get(state, 'frameIndex', 0);

        let messageStructure = {};

        if (key) {
            messageStructure = Chapters[key][index];
        }

        return messageStructure;
    },

    getCurrentMessagesIndexes: function (sceneKey, frameIndex) {
        const messagesIndexes = {};
        const key = !sceneKey ? this.props.sceneKey : sceneKey;

        if (key) {
            const len = Object.keys(Chapters[key]).length;
            for (let i = 0; i < len; i += 1) {
                messagesIndexes[i] = 0;
            }
        }

        return messagesIndexes;
    },

    getFrameStateFromX: function (newX, round = false) {
        let x = newX;

        const props = this.props;
        const state = this.state;
        const { messageBoxPlaying } = this.context;
        const mainContainer = props.mainContainer;
        const scale = _.get(mainContainer, 'parent.scale.x', 1);

        const frameWidth = (props.frameWidth + props.frameBorder) / scale;
        x -= (frameWidth / 2);
        const diff = -newX / frameWidth;
        const index = round === true ? Math.max(0, Math.round(diff)) : Math.max(0, Math.floor(diff)); // Tweak this

        const offset = Math.max(0, diff - index);

        let exactOffset = -x / (frameWidth + 0.5);
        let exactIndex = Math.floor(exactOffset);
        exactOffset -= exactIndex;
        exactIndex -= 1;

        const object = {
            frameIndex: index,
            frameOffset: offset,
            exactFrameIndex: exactIndex,
            exactFrameOffset: exactOffset,
            startY: index !== state.frameIndex ? 0 : state.startY,
            messageBoxPlaying,
        };

        object.framesPlaying = state.framesPlaying;
        if (state.frameOffset !== offset) {
            object.framesPlaying = this.getFramesPlaying(index, offset, false);
        }

        return object;
    },

    updateOverrideMessages: function (messages) {
        this.setState({
            currentMessages: messages,
            overrideMessages: messages,
        });
    },

    updateInteractionsMessages: function (messages) {
        this.setState({
            currentMessages: messages,
            interactionsMessages: messages,
        });
    },

    animateToSlide: function (index) {
        // console.log('animation', index);
        const newIndex = typeof index !== 'undefined' ? index : this.state.frameIndex;
        if (this.state.frameIndex === newIndex) return;

        const props = this.props;
        const mainContainer = props.mainContainer;
        const scale = _.get(mainContainer, 'parent.scale.x', 1);
        const frameWidth = (props.frameWidth + (props.frameBorder)) / scale;

        if (mainContainer) {
            const newX = newIndex * -(frameWidth);

            // const currentFrameState = this.getFrameStateFromX(mainContainer.x);

            // currentFrameState.messageBoxPlaying = false;
            // currentFrameState.currentMessages = [];
            // currentFrameState.isTransitionning = true;

            // this.setState(currentFrameState, () => {
            TweenMax.to(mainContainer, 0.6, {
                x: newX,
                onComplete: () => {
                    const state = this.getFrameStateFromX(mainContainer.x);
                    state.messageBoxPlaying = false;
                    this.setState(state);
                },
            });
        }
    },

    clickToSlide: function (index) {
        const newIndex = typeof index !== 'undefined' ? index : this.state.frameIndex;
        const props = this.props;
        const mainContainer = props.mainContainer;
        const scale = _.get(mainContainer, 'parent.scale.x', 1);
        const frameWidth = (props.frameWidth + (props.frameBorder)) / scale;

        if (mainContainer) {
            const newX = newIndex * -(frameWidth);
            const currentFrameState = this.getFrameStateFromX(mainContainer.x);
            // let framesPlaying = currentFrameState.framesPlaying;
            // let midState = null;

            currentFrameState.messageBoxPlaying = false;
            currentFrameState.currentMessages = [];
            currentFrameState.isTransitionning = true;

            this.setState(currentFrameState, () => {
                TweenMax.to(mainContainer, 0.5, {
                    x: newX,
                    onComplete: () => {
                        const completedFrameState = this.getFrameStateFromX(mainContainer.x);
                        completedFrameState.isTransitionning = false;
                        this.setState(completedFrameState);
                    },
                });
            });
        }
    },

    updateFrameFromDelta: function (delta, opts) {
        const newOpts = _.extend({
            autoSnap: true,
            useMomentum: true,
            snapAfterDelay: true,
        }, opts);

        const props = this.props;
        const context = this.context;
        const mainContainer = props.mainContainer;
        if (mainContainer === null) {
            return;
        }
        const scale = _.get(mainContainer, 'parent.scale.x', 1);
        const framesCount = props.framesClasses.length;
        const frameWidth = (props.frameWidth + props.frameBorder) / scale;

        // let frameIndex = 0;
        // let frameOffset = 0;
        // let exactFrameIndex = 0;
        // let exactFrameOffset = 0;

        const minX = props.snap ? -frameWidth * (framesCount - 1) : 0;
        const newX = Math.min(0, Math.max(minX, (mainContainer.x + delta) / scale));
        TweenMax.killTweensOf(mainContainer);
        mainContainer.x = newX;

        if (!props.snap && !_.get(context.scenesCompleted, props.sceneKey) && newX === minX) {
            // eslint-disable-next-line new-cap
            context.store.dispatch(new StageActions.completeScene(props.sceneKey));
        }

        const frameState = this.getFrameStateFromX(newX, true);

        if (newOpts.useMomentum) {
            const momentumX = this.state.momentumX;
            frameState.momentumX = delta > 0 ? Math.max(momentumX, delta) : Math.min(momentumX, delta);

            clearTimeout(this.momentumXtimeout);
            this.momentumXtimeout = setTimeout(() => {
                this.setState({
                    momentumX: this.state.frameOffset < 0.5 ? -1 : 1,
                });
            }, 100);
        }

        this.setState(frameState, () => {
            if (opts.autoSnap) {
                clearTimeout(this.autoSnapTimeout);
                this.autoSnapTimeout = setTimeout(() => {
                    this.onMouseUp();
                }, opts.snapAfterDelay ? 1000 : 100);
            }
        });
    },

    updateFrameIndex: function () {
        const props = this.props;
        const state = this.state;
        const context = this.context;

        context.store.dispatch(
            new StageActions.setFrameDone(props.sceneKey, state.frameIndex),
        );

        this.setState({
            currentMessages: this.getCurrentMessages(),
            interactionsMessages: null,
        }, () => {
            if (props.onFrameIndexChanged) {
                props.onFrameIndexChanged(state.frameIndex, state.frameOffset, props.framesClasses.length);
            }

            if (props.snap && !_.get(context.scenesCompleted, props.sceneKey) && state.frameIndex === props.framesClasses.length - 1) {
                context.store.dispatch(new StageActions.completeScene(props.sceneKey));
            }

            context.store.dispatch(new StageActions.completeInteraction('switch_frame'));
            context.store.dispatch(new StageActions.uncompleteInteraction('change_intensity'));
        });
    },

    updateFrameOffset: function () {
        const props = this.props;
        const state = this.state;

        if (props.onFrameOffsetChanged) {
            props.onFrameOffsetChanged(state.frameIndex, state.frameOffset, props.framesClasses.length);
        }
    },

    updateExactFrameIndex: function() {
        const props = this.props;
        const state = this.state;

        if (props.onExactFrameIndexChanged) {
            props.onExactFrameIndexChanged(state.exactFrameIndex, state.exactFrameOffset, props.framesClasses.length);
        }
    },

    updateExactFrameOffset: function() {
        const props = this.props;
        const state = this.state;

        if (props.onExactFrameOffsetChanged) {
            props.onExactFrameOffsetChanged(state.exactFrameIndex, state.exactFrameOffset, props.framesClasses.length);
        }
    },

    updateAmbiance: function() {
        let volume = this.context.crisisSound ? 0.35 : 0.1; // ((parseFloat(this.props.intensity + 1)) / 10).toFixed(1); // ;
        if (this.props.intensity === 1) {
            volume = 0.3;
        }

        // console.log('UA');

        if (this.props.sceneKey === null) {
            if (this.audios.intensity1) {
                this.audios.intensity1.fadeIn(this.state.backgroundVolume);
                this.setState({
                    backgroundVolume: volume,
                    currentAmbiance: this.audios.intensity1,
                });
            }
        } else {
            const ambianceStr = this.context.crisisSound ? 'crisis' : `intensity${this.props.intensity}`;
            const currentAmbiance = this.state.currentAmbiance;
            const nextAmbiance = _.get(this.audios, ambianceStr, null);

            // console.log('sound switch', currentAmbiance, nextAmbiance);

            if (currentAmbiance !== null && nextAmbiance !== null) {
                if (currentAmbiance.url === nextAmbiance.url) {
                    return;
                }
            }

            if (currentAmbiance) {
                currentAmbiance.fadeOutFast();
            }

            if (nextAmbiance) {
                this.setState({
                    backgroundVolume: volume,
                    currentAmbiance: nextAmbiance,
                }, () => {
                    nextAmbiance.fadeIn(volume);
                });
            }
        }

        // console.log('ambiance', this.context.crisis, this.props.intensity);
    },

    // THIS ONE MUST BE CHANGED FOR MOBILE PERF
    getFramesPlaying: function (index, offset) {
        const framesCount = this.props.framesClasses.length;

        const frames =  _.times(framesCount).map((i) => {
            let valid = false;
            if (i === index) {
                valid = true;
            } else if (i === index - 1) {
                valid = offset < 0.5;
            } else if (i === index + 1) {
                valid = offset > 0.5;
            }
            return valid;
        });
        return frames;
    },

    getFrameIndexFromDir: function (dir) {
        const totalFrames = this.props.framesClasses.length;
        return Math.max(0, Math.min(totalFrames, this.state.frameIndex + dir));
    },

    getPrevFrameIndex: function() {
        return this.getFrameIndexFromDir(-1);
    },

    getNextFrameIndex: function() {
        return this.getFrameIndexFromDir(1);
    },

    isInConclusionFrame: function () {
        return this.state.showConclusion && this.state.exactFrameIndex >= this.props.framesClasses.length;
    },

    goNextChapter: function(sceneKey) {
        this.props.onSceneChange(sceneKey);
    },

    goPrevSlide: function() {
        this.changeSlide('left');
    },

    goNextSlide: function() {
        this.changeSlide('right');
    },

    changeSlide: function(direction) {
        const { sceneKey, objectsWithTextures, mainContainer } = this.props;
        if (objectsWithTextures === null || mainContainer === null || this.context.crisis) {
            return;
        }

        const key = sceneKey || '';
        const frames = Chapters[key.toLowerCase()] || {};
        const nextFrame = this.getNextFrameIndex();

        // Exceptions, first and last
        if (direction === 'left' && this.state.frameIndex === 0 && sceneKey === 'intro') return;
        if (direction === 'right' && nextFrame >= Object.keys(frames).length && sceneKey === 'oligarchie') return;

        if (mainContainer) {
            // Switch from one chapter to another
            const state = this.getFrameStateFromX(mainContainer.x);
            // Max before
            if (state.frameIndex === 0 && direction === 'left') {
                let nextKey = 0;
                Scenes.forEach((scene, idx) => {
                    if (scene.name === sceneKey) {
                        nextKey = idx - 1;
                    }
                });
                if (Scenes[nextKey]) {
                    this.goNextChapter(Scenes[nextKey].name);
                }
            // Max after
            } else if (state.frameIndex === state.framesPlaying.length - 1 && direction === 'right') {
                let nextKey = 0;
                Scenes.forEach((scene, idx) => {
                    if (scene.name === sceneKey) {
                        nextKey = idx + 1;
                    }
                });
                if (Scenes[nextKey]) {
                    this.goNextChapter(Scenes[nextKey].name);
                }
            // Switch in the right direction
            } else {
                this.clickToSlide(direction === 'right' ? nextFrame : this.getPrevFrameIndex());
            }
        }
    },

    openLearnMore: function (key, content = {}) {
        this.context.store.dispatch(StageActions.updateLearnMore(true, key, content));
        this.context.store.dispatch(StageActions.setPlaying(false));
    },

    startInteractionsTimeout: function () {
        this.interactionsTimeout = setTimeout(
            this.onInteractionsTimeoutReached,
            this.props.interactionsTimeout * 1000,
        );
    },

    stopInteractionsTimeout: function () {
        if (this.interactionsTimeout) {
            clearTimeout(this.interactionsTimeout);
            this.interactionsTimeout = null;
        }
    },

    /*
     * Event handlers
     */

    onMessengerHeightChange: function (size) {
        this.setState({
            messengerHeight: size || 0,
        });
    },

    onResumeMessageBox: function () {

    },

    onMessageWillShow: function (message) {
        if (this.props.onMessageWillShow) {
            this.props.onMessageWillShow(message);
        }
    },

    onMessageShow: function (message, index) {
        if (this.props.onMessageShow && message !== null) {
            this.props.onMessageShow(message);
        }
    },

    onStoreMessages(currentMessages, currentAnswers, currentIndex) {
        const { pastMessages, pastAnswers, pastIndexes } = this.state;

        const clonedPastMessages = _.cloneDeep(pastMessages);
        const clonedPastAnswers = _.cloneDeep(pastAnswers);
        const frameIndex = _.get(this.state, 'frameIndex', 0);

        clonedPastMessages[frameIndex] = currentMessages;
        clonedPastAnswers[frameIndex] = currentAnswers;

        if (!pastIndexes[frameIndex]) {
            pastIndexes[frameIndex] = 0;
        }

        pastIndexes[frameIndex] = currentIndex;

        // You're now sure everything is started.
        // const resize = Object.keys(pastMessages).length === 0 && pastMessages.constructor === Object;

        this.setState({
            pastMessages: clonedPastMessages,
            pastAnswers: clonedPastAnswers,
            pastIndexes,
        }, () => {
            // console.log('store update', this.state.pastMessages, this.state.pastAnswers, this.state.pastIndexes);
            // if (resize) {
            //
            // }
        });
    },

    onAllMessagesShown: function () {
        this.stopInteractionsTimeout();

        if (!this.context.crisis) {
            this.startInteractionsTimeout();
        }
    },

    onInteractionsTimeoutReached: function () {
        cnsole.log('int timeout');
        this.interactionsTimeout = null;
        const sceneKey = this.props.sceneKey;
        const frameIndex = this.state.frameIndex;
        const interactionsCompleted = this.context.interactionsCompleted;

        const interactions = [
            'change_intensity',
            'switch_frame',
        ];
        let messages = null;
        _.each(interactions, function(interaction) {
            if (!interactionsCompleted[interaction]) {
                messages = _.get(Texts, 'scenes.'+sceneKey+'.frames.'+frameIndex+'.interactions.'+interaction, null);
            }
        });

        if (messages && messages.length) {
            messages = _.isArray(messages) ? messages : [messages];
            const lastIndex = messages.length - 1;
            const clearDelay = this.props.interactionsMessageClearDelay;
            messages = messages.map(function(text, index) {
                var message = {
                    text: text,
                    color: 'yellow',
                };
                if (index === lastIndex) {
                    // message.clearDelay = clearDelay;
                }
                return message;
            });
            this.updateInteractionsMessages(messages);
        }
    },

    onIntensitySelectorClick: function () {
        this.context.store.dispatch(StageActions.completeInteraction('change_intensity'));
    },

    onIntensityChanged: function () {
        this.updateAmbiance();
    },

    onCrisisChanged: function () {
        this.updateAmbiance();
        if (this.context.crisis) {
            console.log('Not sure why this exists');
            // this.goToSlide();
        }
    },


    // onMessageYPositionChanged: function(deltaY) {
        // // Offset the message box so you can read better
        // const displacement = this.state.startY + deltaY;
        // const topLimit = this.state.messengerHeight - Math.floor(this.props.frameHeight / 10);
        // const bottomLimit = 0; // -(this.props.frameHeight / 2);
        //
        // if (displacement < topLimit
        //     && displacement >= bottomLimit) {
        //     const startY = this.state.startY + deltaY;
        //     this.setState({
        //         startY, // This one moves the message boxes
        //         // messageBoxPlaying: startY <= 0, // <= bottomLimit - 1,
        //     }, () => {
        //         // console.log('the new Y', this.state.startY);
        //     });
        // }
    // },

    onTick: function() {
        // const props = this.props;
        // const state = this.state;
        // const frameIndex = state.frameIndex;
        // const totalFrames = props.framesClasses.length;
        //
        // if (frameIndex === 0 || frameIndex >= totalFrames - 1 || props.intensity === null || !props.showIntensitySelector || props.framesTransitions[frameIndex]) {
        //     return;
        // }

        // this.frameCount++;
        // if (this.frameCount % this.props.instabilityUpdateFramesCount === 0)
        // {
        //     if (this.context.crisis) {
        //
        //     } else {
        //         // this.context.store.dispatch(CrisisActions.updateInstability());
        //     }
        // }
    },

    onMouseDown: function(opts) {
        this.setState({
            panStartY: this.state.startY || 0, // opts.event.center.y,
        });
    },

    onMouseMove: function (opts) {

        const snap = this.props.snap;
        const deltaX = opts.deltaX;
        const deltaY = opts.deltaY;
        const highestDelta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

        if (!opts.mouseDown
            || !this.context.playing
            || (deltaX === 0 && deltaY === 0)
            || this.props.pageKey !== null
            || this.context.messageBoxPlaying !== true) {
            return;
        }

        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            this.updateFrameFromDelta(deltaX, {
                // autoSnap: snap,
                useMomentum: snap,
                // snapAfterDelay: Math.abs(highestDelta) > 6,
            });
        } else if (Math.abs(deltaY) > Math.abs(deltaX)) {
            // Not sure about this
            // const maxHeight = this.state.messengerHeight;
            // const currentY = this.state.startY + deltaY;
            // let startY = 0;
            // if (currentY < 0) {
            //     startY = 0;
            // } else {
            //     startY = Math.min(currentY, maxHeight);
            // }
            //
            // console.log(startY, maxHeight);
            //
            // this.setState({
            //     startY,
            // });
        }
    },

    onPanStart: function (opts) {
        // if (this.context.menuOpen) {
        //     console.log('hallo');
        // }
        this.setState({
            panStartY: this.state.startY || 0, // opts.event.center.y,
        });
    },

    onPan: function (opts) {
        if ( this.state.panStartY === null
            || this.props.learnMoreOpened
            || this.props.pageKey !== null
            || !this.context.playing
            || this.context.messageBoxPlaying !== true) {
            return;
        }

        const maxHeight = this.state.messengerHeight;
        const panStartY = this.state.panStartY;
        const angle = opts.event.angle;
        const deltaY = angle > 0 ? opts.event.distance : -opts.event.distance;
        const currentY = panStartY + deltaY;

        let startY = 0;
        if (currentY < 0) {
            startY = 0;
        } else {
            startY = Math.min(currentY, maxHeight);
        }

        // console.log('onpan', currentY, maxHeight, this.state.messengerHeight, this.props.frameHeight);

        this.setState({
            startY,
            // messageBoxPlaying: startY <= 0, // <= bottomLimit - 1,
        });
    },

    onPanEnd: function(opts) {
        this.setState({
            panStartY: null,
        });
    },

    onMouseUp: function(opts) {
        if (this.props.learnMoreOpened
            || !this.props.snap
            || !this.context.playing
            || this.props.pageKey !== null
            || (this.state.showConclusion
                && this.state.exactFrameIndex > this.props.framesClasses.length)) {
            return;
        }

        const state = this.state;
        const momentumX = state.momentumX;
        const mouseMoved = momentumX !== 0;
        // const momentumReached = Math.abs(momentumX) > this.props.minMomentumXforNextSlide;
        const offset = state.frameOffset;
        const isDirectionRight = momentumX < 0;
        const validMomentum =
            (isDirectionRight && offset > 0.5) || (!isDirectionRight && offset < 0.5);
        let nextFrameIndex = state.frameIndex;

        // Don't switch on click anymore, it's stupid
        if (!mouseMoved) {
            // const clientX = _.get(opts, 'event.clientX', props.width);
            // nextFrameIndex = clientX > props.width / 2 - props.frameWidth / 2
            // ? this.getNextFrameIndex():this.getPrevFrameIndex();
        // Try to get the next one
        } else if (validMomentum && this.context.messageBoxPlaying === true) {
            nextFrameIndex = isDirectionRight ? this.getNextFrameIndex() : this.getPrevFrameIndex();
        }

        clearTimeout(this.momentumXtimeout);

        this.animateToSlide(nextFrameIndex);

        this.setState({
            momentumX: 0,
            panStartY: null,
        });
    },

    onMouseWheel: function (opts) {
        // const snap = this.props.snap;
        // const deltaX = opts.event.deltaX;
        // const deltaY = opts.event.deltaY;
        // const highestDelta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

        // if (this.context.messageBoxPlaying === false) {
        //     this.onMessageYPositionChanged(deltaY);
        // }

        if (this.props.learnMoreOpened
            || this.props.menuOpened
            || !this.context.playing
            || this.context.messageBoxPlaying !== true) {
            return;
        }

        // this.updateFrameFromDelta(-highestDelta, {
        //     autoSnap: snap,
        //     useMomentum: snap,
        //     snapAfterDelay: Math.abs(highestDelta) > 6,
        // });

        const maxHeight = this.state.messengerHeight;
        // const panStartY = this.state.panStartY || 0;
        // const angle = opts.event.angle;
        // const deltaY = angle > 0 ? opts.event.distance : -opts.event.distance;
        // const deltaY = opts.event.deltaY;
        const deltaY = normalizeWheel(opts.event.nativeEvent).pixelY;
        const currentY = this.state.startY + deltaY;

        // console.log(opts.event.deltaY, deltaY);

        let startY = 0;
        if (currentY < 0) {
            startY = 0;
        } else {
            startY = Math.min(currentY, maxHeight);
        }

        // console.log('onWheel', this.state.messengerHeight, deltaY, this.state.startY);

        this.setState({
            startY,
        });
    },

    // LearnMore

    onLearnMoreOpened: function (deltaY, duration) {
        TweenMax.to(document.getElementsByClassName('app-content'), duration, {
            y: `-${this.props.height}`,
            ease: Quad.easeInOut,
        });
    },

    onLearnMoreClosed: function (deltaY, duration) {
        TweenMax.to(document.getElementsByClassName('app-content'), duration, {
            y: 0,
            ease: Quad.easeInOut,
        });
    },

    onLearnMoreButtonClick: function (opened) {
        const key = `scenes.${this.props.sceneKey}.frames.${this.state.frameIndex}.learnMore`;
        const content = opened ? _.get(Texts, key, null) : null;
        console.log('queso');
        this.context.store.dispatch(StageActions.updateLearnMore(false, this.context.learnMoreKey, content));
        this.context.store.dispatch(StageActions.setPlaying(true));
    },

    // Menu

    onMenuOpened: function (deltaY, duration) {
        TweenMax.to(document.getElementsByClassName('app-content'), duration, {
            y: this.props.height,
            ease: Quad.easeInOut,
        });
    },

    onMenuClosed: function (deltaY, duration) {
        TweenMax.to(document.getElementsByClassName('app-content'), duration, {
            y: 0,
            ease: Quad.easeInOut,
        });
    },

    // onMenuButtonClick: function (opened) {
    //     this.props
    //     this.context.store.dispatch(StageActions.setMenuOpen(!this.context.menuOpen));
    // },

    onSceneChange: function (sceneKey) {
        if (this.state.exactFrameOffset !== 0) {
            return;
        }
        if (this.props.onSceneChange) {
            this.props.onSceneChange(sceneKey);
        }
    },

    onConclusionFrameWidthChange: function(frameWidth) {
        this.setState({
            conclusionFrameWidth: frameWidth,
        });
    },

    onMessengerAnimationCall(animationData) {
        this.setState({
            animationData,
        });
    },
});

module.exports = Scene;



// WEBPACK FOOTER //
// ./js/components/views/Scene.jsx